import AsyncStorage from '@react-native-async-storage/async-storage';
import { createScopedLogger } from '@/utils/logging/createScopedLogger';

const log = createScopedLogger('jsonStorage');

export async function getJSON<T>(key: string): Promise<T | null> {
  try {
    const raw = await AsyncStorage.getItem(key);
    if (raw == null) return null;
    return JSON.parse(raw) as T;
  } catch (error) {
    log.error(`getJSON failed for ${key}:`, error);
    return null;
  }
}

export async function setJSON<T>(key: string, value: T): Promise<boolean> {
  try {
    await AsyncStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    log.error(`setJSON failed for ${key}:`, error);
    return false;
  }
}

export async function removeJSON(key: string): Promise<boolean> {
  try {
    await AsyncStorage.removeItem(key);
    return true;
  } catch (error) {
    log.error(`removeJSON failed for ${key}:`, error);
    return false;
  }
}

export async function multiGetJSON<T>(keys: string[]): Promise<Map<string, T>> {
  const result = new Map<string, T>();
  try {
    const entries = await AsyncStorage.multiGet(keys);
    for (const [key, raw] of entries) {
      if (raw == null) continue;
      try {
        result.set(key, JSON.parse(raw) as T);
      } catch {
        /* ignore parse errors per-key */
      }
    }
  } catch (error) {
    log.error('multiGetJSON failed:', error);
  }
  return result;
}

export async function multiRemove(keys: string[]): Promise<boolean> {
  if (keys.length === 0) return true;
  try {
    await AsyncStorage.multiRemove(keys);
    return true;
  } catch (error) {
    log.error('multiRemove failed:', error);
    return false;
  }
}
